import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { authAPI } from '../api/client';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user,    setUser]    = useState(() => {
    try { return JSON.parse(localStorage.getItem('ef_user')); } catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('ef_token');
    if (!token) { setLoading(false); return; }
    authAPI.me()
      .then(({ data }) => {
        setUser(data.user);
        localStorage.setItem('ef_user', JSON.stringify(data.user));
      })
      .catch(() => {
        localStorage.removeItem('ef_token');
        localStorage.removeItem('ef_user');
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await authAPI.login({ email, password });
    localStorage.setItem('ef_token', data.token);
    localStorage.setItem('ef_user',  JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  }, []);

  /* signup returns:
     - { needsVerification: true } → show OTP screen
     - { user } → logged in directly (email disabled) */
  const signup = useCallback(async (formData) => {
    const { data } = await authAPI.signup(formData);
    if (data.email_verification_required) {
      return { needsVerification: true, message: data.message };
    }
    localStorage.setItem('ef_token', data.token);
    localStorage.setItem('ef_user',  JSON.stringify(data.user));
    setUser(data.user);
    return { user: data.user };
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('ef_token');
    localStorage.removeItem('ef_user');
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, signup, logout, isAdmin: user?.role === 'admin' }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};
